;(async () => {
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')
  Promise.all([import(/* webpackMode: "eager" */ './sub-nav-block.scss')]).then(() => {
    $('.widget.sub-nav-block').each(function (i, el) {
      $(el).data('widget', new SubNavBlock(el, Swiper))
      $(el).data('widget').init()
    })
  })
})()

function SubNavBlock(el, Swiper) {
  const self = this
  self.el = $(el)
  self.swiper = null
  self.swiperEl = self.el.find('.swiper-container')
  self.navItemsContainer = self.el.find('.js-nav-items-container')
  self.anchorItems = document.querySelectorAll('.js-sub-nav-block-anchor')
  self.itemTemplate = require('./sub-nav-block-item.hbs')
  console.log('anchorItems', self.anchorItems)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('SubNavBlock init', self)
    }

    if (self.anchorItems.length > 0) {
      constructNavItems(self.anchorItems)
      checkOverflowAndToggleSwiper()
      bindEvents()
    } else {
      console.warn('SubNavBlock: No anchor items found, skipping initialization and hiding.')
      self.el.addClass('hidden')
    }
  }

  function constructNavItems(items) {
    // Clear existing cards
    const swiperWrapperEl = self.el.find('.js-swiper-wrapper')
    swiperWrapperEl.empty()

    // Create cards HTML
    const itemsFragment = new DocumentFragment()
    items.forEach((item) => {
      const template = document.createElement('template')
      template.innerHTML = self.itemTemplate({
        id: item.id,
        label: item.getAttribute('data-label') || '',
      })
      itemsFragment.append(template.content)
    })

    // Append cards to the DOM
    swiperWrapperEl.append(itemsFragment)
  }

  function bindEvents() {
    window.addEventListener('resize', dbs.utilities.throttle(checkOverflowAndToggleSwiper, 75))

    self.navItemsContainer.find('a[href^="#"]').on('click', function (e) {
      e.preventDefault()

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
      })
    })
  }

  function checkOverflowAndToggleSwiper() {
    console.log('SubNavBlock: checking overflow and toggling swiper')
    const isOverflowing = self.swiperEl[0].scrollWidth > self.navItemsContainer[0].clientWidth

    if (isOverflowing && !self.swiper) {
      console.log('SubNavBlock: initializing swiper')
      // Remove 'flex' to prevent swiper issues
      self.navItemsContainer.removeClass('flex')
      // Initialize Swiper
      self.swiper = new Swiper(self.swiperEl, {
        loop: false,
        autoHeight: false,
        watchOverflow: true,
        slidesPerView: 'auto',
      })
    } else if (!isOverflowing && self.swiper) {
      console.log('SubNavBlock: destroying swiper')
      // Add 'flex' to center the tabs
      self.navItemsContainer.addClass('flex')
      // Destroy Swiper
      self.swiper.destroy(true, true)
      self.swiper = null
    }
  }
}
